import {
    IMG_PAGE_SIZES, NEW_BACKGROUND_REQUESTED,
    PDF_PAGE_SIZES, PDF_PAGE_UNIT,
    PDF_TOGGLE_MODAL,
    PIPES_PDF_TOGGLE_MODAL,
    PROJECTS_CRUD_RESTORE_STATE,
} from "../lib/types";

const initialState = {
    showPdfModal: false,
    showPipesPdfModal: false,
    pdfPageSizes: {
        ptWidth: 0,
        ptHeight: 0,
        inWidth: 0,
        inHeight: 0,
        mmWidth: 0,
        mmHeight: 0,
    },
    imgPageSizes: {
        width: 0,
        height: 0,
    },
    scalingImageDataPresent: true,
    imperialUnit: true,
};

export let PdfReducer = ( state = initialState, action ) => {
    switch (action.type) {
        case PDF_TOGGLE_MODAL:
            return {
                ...state,
                showPdfModal: action.payload,
            };

        case PIPES_PDF_TOGGLE_MODAL:
            return {
                ...state,
                showPipesPdfModal: action.payload,
            };

        case PDF_PAGE_SIZES:
            return {
                ...state,
                pdfPageSizes: action.payload,
                scalingImageDataPresent: true,
            };

        case IMG_PAGE_SIZES:
            return {
                ...state,
                imgPageSizes: {
                    width: action.payload.width,
                    height: action.payload.height,
                },
                scalingImageDataPresent: true,
            };

        case PDF_PAGE_UNIT:
            return {
                ...state,
                imperialUnit: action.payload,
            };

        case PROJECTS_CRUD_RESTORE_STATE:
            /* receive the new state */
            let rState = action.payload.pdf;
            /* restore image base64 */

            if (rState && rState.pdfPageSizes && rState.imgPageSizes) {
                return {
                    ...rState,
                    pdfPageSizes: rState.pdfPageSizes,
                    imgPageSizes: rState.imgPageSizes,
                    scalingImageDataPresent: true,
                };
            } else {
                return {
                    ...rState,
                    pdfPageSizes: {
                        ptWidth: 0,
                        ptHeight: 0,
                        inWidth: 0,
                        inHeight: 0,
                        mmWidth: 0,
                        mmHeight: 0,
                    },
                    imgPageSizes: {
                        width: 0,
                        height: 0,
                    },
                    scalingImageDataPresent: false,
                };
            }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/pdf-reducer.js